import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';


class review26_3 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>3</h1><br></br>
                           
                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. คำกล่าวเกี่ยวกับอาณาจักรทวารวดีในข้อใดถูกต้องที่สุด</h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เป็นอาณาจักรแห่งแรกในดินแดนไทย</h5>
                           <h5 className="textreviewF">ข. ช่วยถ่ายทอดวัฒนธรรมไปสู่ดินแดนอื่น</h5>
                           <h5 className="textreviewF">ค. นำดินแดนไทยเข้าสู่สมัยประวัติศาสตร์</h5>
                        </Form>

                        <h5 className="textreview">3. การใช้คำบอกเวลาในข้อใดที่สามารถจะระบุเวลาที่เกิดเหตุการณ์ได้ชัดเจนที่สุด</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เดือน  ปี  ศักราช</h5>
                           <h5 className="textreviewF">ข. ยุคสมัย  ศตวรรษ</h5>
                           <h5 className="textreviewF">ค. กาลครั้งหนึ่งนานมาแล้ว</h5>
                           <h5 className="textreviewF">ง. ยุคก่อนประวัติศาสตร์</h5>
                        </Form>

                        <h5 className="textreview">4. การรู้จักเทียบศักราชมีประโชน์ในการศึกษาประวัติศาสตร์อย่างไร</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. ช่วยให้สรุปเรื่องราวทางประวัติศาสตร์ได้ถูกต้อง</h5>
                           <h5 className="textreviewF">ข. ให้สามารถอ่านตีความเอกสารของต่างชาติได้</h5>
                           <h5 className="textreviewF">ค. ช่วยให้ใช้เอกสารที่ระบุเวลาได้เกือบทุกชนิด</h5>
                           <h5 className="textreviewT">ง. มีความเข้าใจเหตุการณ์และเรื่องราวได้ง่ายขึ้น</h5>
                        </Form>

                        <h5 className="textreview">5. “ชื่อเมืองธนบุรีนั้นเห็นจะใช้ชื่อเดิมตั้งแต่เมื่อแรกสร้างปรากฏในพระราชกำหนดเก่า  ซึ่งตราไว้เมื่อปีกุน จุลศักราช 1069” จุลศักราชที่ระบุไว้นี้   สามารถเทียบได้กับศักราชข้อใด</h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. มหาศักราช  2817</h5>
                           <h5 className="textreviewF">ข. พุทธศักราช 2205</h5>
                           <h5 className="textreviewF">ค. รัตนโกสินทร์ศก 2324</h5>
                           <h5 className="textreviewT">ง. คริต์ศักราช 2793</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review26_3